import auth0 from './client'
import { CYPRESS_AUTH_BYPASS } from 'env'

const CYPRESS_AUTH_TOKEN_STORAGE_KEY = 'pga-cypress-auth-token'

const getToken = async () => {
  if (CYPRESS_AUTH_BYPASS && window.Cypress) {
    return window.localStorage.getItem(CYPRESS_AUTH_TOKEN_STORAGE_KEY)
  }

  try {
    const accessToken = await auth0.getTokenSilently()
    return accessToken
  } catch (error) {
    const skippedErrors = [
      'login_required',
      'mfa_required',
      'missing_refresh_token',
      'invalid_grant',
    ]
    if (!skippedErrors.includes(error.error)) {
      console.error(error)
      window.rg4js &&
        window.rg4js('send', {
          error,
          tags: ['auth'],
        })
      throw error
    }
    return null
  }
}

export { getToken }
